import { datalayerEvent } from './dataLayer.js';
console.log("app.js loaded");

import ScrollReveal from 'scrollreveal';

const mobileMaxWidth = 767;
const html = document.documentElement;
const body = document.body;

let quantitySelectors;

//mobile screen size detect
window.isMobile = (window.innerWidth <= mobileMaxWidth);


const preventBodyScroll = () =>
{
    body.classList.add('noscroll');
}
const allowBodyScroll = () =>
{
    body.classList.remove('noscroll');
}

window.csrfToken = () =>
{
    return document.querySelector('meta[name="csrf-token"]').getAttribute('content');
}

window.stripTags = (html) =>
{
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent || div.innerText || '';
}

//pop-out menus

window.togglePopOutMenu = (popOutMenuId,forceState=null) =>
{
    const popOutMenu = document.querySelector("[data-pop-out-menu-id="+popOutMenuId+"]");
    const toggleButtons = document.querySelectorAll("[data-pop-out-menu-toggle="+popOutMenuId+"]");

    if (popOutMenu)
    {
        if (forceState=="close")
        {
            popOutMenu.classList.remove('active');
        }
        else if (forceState=="open")
        {
            popOutMenu.classList.add('active');
        }
        else
        {
            popOutMenu.classList.toggle('active');
        }
        if (toggleButtons.length)
        {
            toggleButtons.forEach(toggleButton =>
            {
                if (forceState=="close")
                {
                    toggleButton.classList.remove('active');
                }
                else if (forceState=="open")
                {
                    toggleButton.classList.add('active');
                }
                else
                {
                    toggleButton.classList.toggle('active');
                }
            });
        }
        if (popOutMenu.classList.contains('active'))
        {
            preventBodyScroll();
        }
        else
        {
            allowBodyScroll();
        }
    }
}

window.displayPrice = function(price)
{
    let num = parseFloat(price);
    if (isNaN(num)) return '';
    const formattedPrice = num.toFixed(2);
    let [integerPart, decimalPart] = formattedPrice.split(".");
    const formattedInteger = new Intl.NumberFormat().format(integerPart);

    if (decimalPart=="00")
    {
        decimalPart="";
    }
    else
    {
        decimalPart="."+decimalPart;
    }

    return `£${formattedInteger}${decimalPart}`;
}

window.setPrice = function (selector,price_ex_vat,price_inc_vat)
{
    const exVatPriceSelector = selector.querySelector(".ex_vat_price");
    const incVatPriceSelector = selector.querySelector(".inc_vat_price");
    if (exVatPriceSelector)
    {
        exVatPriceSelector.dataset.raw = price_ex_vat;
        exVatPriceSelector.querySelector(".ex_vat_value").textContent = window.displayPrice(price_ex_vat);
    }
    if (incVatPriceSelector)
    {
        incVatPriceSelector.dataset.raw = price_inc_vat;
        incVatPriceSelector.querySelector(".inc_vat_value").textContent = window.displayPrice(price_inc_vat);
    }
}

window.scrollToElement = function (selector)
{
    const element = document.querySelector(selector);
    if (element)
    {
        const yOffset = -100; // Adjust this value to scroll above the element
        const y = element.getBoundingClientRect().top + window.scrollY + yOffset;
        window.scrollTo({ top: y, behavior: "smooth" });
    }
}

window.showModal = function(modal_id)
{
    const modal = document.querySelector("#modals_container .modal[data-modal-id=\""+modal_id+"\"");
    if (modal)
    {
        modal.classList.add("visible");
        modal.dispatchEvent(new Event('show'));
        const focusField = modal.querySelector("[data-focus-on-show-modal]");
        if (focusField)
        {
            focusField.focus();
        }
    }
}

window.hideModal = function(modal_id = null)
{
    let modals, modal_to_close;
    if (modal_id!==null)
    {
        modal_to_close = document.querySelectorAll("#modals_container .modal[data-modal-id=\""+modal_id+"\"");
    }
    else
    {
        modals = document.querySelectorAll("#modals_container .modal");

        for (let modal of modals)
        {
            const rect = modal.getBoundingClientRect();

            // Check the center point of the modal
            const centerX = rect.left + rect.width / 2;
            const centerY = rect.top + rect.height / 2;

            const topElement = document.elementFromPoint(centerX, centerY);

            // Check if the modal is the topmost at its own center
            if (modal.contains(topElement) || modal === topElement)
            {
                modal_to_close = modal;
            }
        }
    }
    modal_to_close.classList.remove("visible");
    modal_to_close.dispatchEvent(new Event('hide'));
}

window.modal = function(content,title = null, rich = false)
{
    const dynamic_modal = document.querySelector("#modals_container .modal[data-modal-id=\"dynamic\"]");
    if (!rich)
    {
        content = "<p>"+content+"</p>";
    }
    if (title==null)
    {
        title = "Message";
    }
    dynamic_modal.querySelector(".modal_header > .h4 > span").innerHTML = title;
    dynamic_modal.querySelector(".modal_content").innerHTML = content;
    window.showModal('dynamic');
}

window.richModal = function(content,title = null)
{
    window.modal(content,title,true);
}

window.fadeLazyLoadImage = function (image)
{
    if (image.complete)
    {
        // If the image is already loaded from cache, add loaded class immediately
        image.classList.add("loaded");
    }
    else
    {
        image.addEventListener("load", () =>
        {
            image.decode().then(() => {
                image.classList.add("loaded");
            }).catch(() => {
                // If something went wrong, add loaded class anyway
                image.classList.add("loaded");
            });
        });
    }
}

window.serialize = function(form)
{
    const formData = new FormData(form);
    const serializedObject = {};

    formData.forEach((value, key) => {
        if (key.endsWith("[]")) {
            if (!serializedObject[key]) {
                serializedObject[key] = [];
            }
            serializedObject[key].push(value);
        } else {
            serializedObject[key] = value;
        }
    });

    return serializedObject;
}

window.basketMessage = function (title,message,button_url,button_text)
{
    basketMessageOrError("message",title,"icon_text tick white",message,button_url,button_text);
}

window.basketError = function (title,error)
{
    basketMessageOrError("error",title,"icon_text warning white",error,"#","Close");
}

/**
 * Keeps the Laravel session alive on pages where a stale CSRF token would
 * silently break AJAX actions (add to basket, checkout steps, etc.).
 *
 * Waits 15 minutes before firing — no request is made if the user leaves the
 * page sooner than that. After the first ping, repeats every 15 minutes.
 *
 * The current URL is included as a query parameter so heartbeat requests are
 * identifiable in nginx access logs.
 *
 * Called from checkout.js, product.js, and portal-product.js on the pages
 * where session expiry would cause the worst user experience.
 */
window.startHeartbeat = function ()
{
    const intervalMinutes = 15;
    const intervalMs = intervalMinutes * 60 * 1000;

    setTimeout(function () {
        function ping() {
            fetch('/heartbeat?url=' + encodeURIComponent(location.href)).catch(() => {});
        }
        ping();
        setInterval(ping, intervalMs);
    }, intervalMs);
}

window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
        location.reload();
    }
});

window.rgbToHex = function (rgb)
{
    const result = rgb.match(/\d+/g).map((num, index) => {
        // Skip alpha channel if rgba
        if (index > 2) return null;
        const hex = parseInt(num).toString(16);
        return hex.padStart(2, '0');
    }).filter(Boolean);

    return `#${result.join('')}`;
}

function basketMessageOrError(message_or_error,title,title_class,content,button_url,button_text)
{
    let message_container;
    if (message_or_error=="error")
    {
        message_container = document.querySelector(".basket_error_container");
        document.querySelector(".basket_message_container").classList.remove("visible");
    }
    else
    {
        message_container = document.querySelector(".basket_message_container");
        document.querySelector(".basket_error_container").classList.remove("visible");
    }
    const basket_nav_link = document.querySelector(".mini_basket_container .nav_link.basket");
    const message_title = message_container.querySelector(".message_title");
    const message_body = message_container.querySelector(".message_body");
    const message_button = message_container.querySelector(".message_footer .button");
    const view_basket_link = message_container.querySelector(".message_footer .view_basket_link");

    basket_nav_link.className = "nav_link basket "+message_or_error;
    message_title.className = "message_title "+title_class;
    message_title.innerHTML = title;
    message_body.innerHTML = content;
    message_button.href = button_url;
    message_button.innerHTML = button_text;

    if (view_basket_link) {
        if (button_text == "View Basket")
        {
            view_basket_link.classList.add("hidden");
        }
        else
        {
            view_basket_link.classList.remove("hidden");
        }
    }

    message_container.classList.add("visible");

}

//* labels on required form fields
window.addRequiredLabel = function(field)
{
    let label;
    let labelType;
    const appendHTML = '<em class="required">*</em>';

    if (
        (field?.tagName === 'INPUT' && field.type === 'radio') ||
        (field?.tagName === 'INPUT' && field.type === 'file')
    )
    {
        return false;
    }

    label = field.closest('label');
    if (label)
    {
        label = field.closest('label');
        if (label.id=="billing_address1")
        {
            console.log(field,label);
        }
        labelType = "wrapped";
    }
    else if (field.id)
    {
        label = document.querySelector('label[for="'+field.id+'"]');
        labelType = "for";
    }
    if (label)
    {
        if (labelType=="for")
        {
            label.innerHTML += appendHTML;
        }
        else
        {
            field.insertAdjacentHTML('beforebegin',appendHTML);
        }
    }
    else
    {
        if (field.id != "newsletter-form-email")
        {
            console.log("Label not found for required field",field);
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {

    //mobile screen size detector
    window.addEventListener('resize', () => {
        window.isMobile = (window.innerWidth <= mobileMaxWidth);
    });

    //scrolling header behaviour
    const fixedHeader = document.getElementById("fixed_header");

    if (fixedHeader)
    {
        window.addEventListener('scroll', () => {
            // Get the current vertical scroll position
            const scrollTop = window.scrollY || html.scrollTop;
            const trustMessaging = document.getElementById("header_trust_messaging");
            const minimalHeader = document.getElementById("page_header").classList.contains("minimal");

            if (((window.isMobile || minimalHeader) && scrollTop > 0) || (!window.isMobile && scrollTop > 90))
            {
                fixedHeader.classList.add("scrolled");
                trustMessaging.classList.add("stuck");
            }
            else
            {
                fixedHeader.classList.remove("scrolled");
                trustMessaging.classList.remove("stuck");
            }
        });
        window.dispatchEvent(new Event('scroll'));
    }

    //duplicate desktop top nav into hamburger nav
    const desktopNav = document.querySelector("nav.desktop_nav > ul");
    const mobileNav = document.querySelector(".main_mobile_nav");

    if (desktopNav)
    {
        mobileNav.innerHTML = desktopNav.innerHTML;
    }

    //pop-out menu events
    document.addEventListener('click',(e) => {
        if (e.target)
        {
            const target = e.target;
            const classList = target.classList;
            if (target.closest('[data-pop-out-menu-toggle]'))
            {
                e.preventDefault;
                window.togglePopOutMenu(target.closest('[data-pop-out-menu-toggle]').getAttribute('data-pop-out-menu-toggle'));
                return;
            }
            else if (classList.contains('pop_out_menu_close') || classList.contains('pop_out_menu_overlay'))
            {
                const isCloseButton = classList.contains('pop_out_menu_close');
                const isOverlay = classList.contains('pop_out_menu_overlay');
                let popOutMenu;
                if (isCloseButton)
                {
                    popOutMenu = target.closest(".pop_out_menu");
                }
                else
                {
                    popOutMenu = target.previousElementSibling;
                }
                if (popOutMenu)
                {
                    window.togglePopOutMenu(popOutMenu.getAttribute("data-pop-out-menu-id"),"close");
                }
            }
            //subnav open / close
            else if (target?.classList?.contains('has_children') || target?.parentNode?.classList?.contains('has_children'))
            {
                console.log(target);
                let nav_li;
                let li_clicked = false;
                if (target.classList.contains('has_children'))
                {
                    nav_li = target;
                    li_clicked = true;
                }
                else
                {
                    nav_li = target.parentNode;
                }
                if (li_clicked || !nav_li.classList.contains('open'))
                {
                    e.preventDefault;
                }
                nav_li.classList.toggle("open");

                console.log("open");
            }
        }
    });

    //modal show / hide events
    document.addEventListener('click',(event) => {
        if (event.target)
        {
            const modalTrigger = event.target.closest('[data-show-modal]');
            if (modalTrigger)
            {
                event.preventDefault();
                window.showModal(modalTrigger.getAttribute('data-show-modal'));
            }
        }
    });
    document.addEventListener('mousedown',(event) => { //needs mousedown for close to stop accidental drags off modal closing it
        if (event.target)
        {
            //check for clicks inside closeable modal
            const modalOuters = document.querySelectorAll("aside.modal.closeable");

            modalOuters.forEach(modalOuter => {
                if (modalOuter.contains(event.target))
                {
                    const modalInner = modalOuter.querySelector(".modal_inner");
                    if (!modalInner.contains(event.target) || event.target.classList.contains('modal_close_button'))
                    {
                        window.hideModal();
                    }
                }
            });
        }
    });

    //hide on escape being pressed
    document.addEventListener("keyup", function(event) {
        if (event.key === "Escape") {
            const modals = document.querySelectorAll("aside.modal");
            modals.forEach(modal => {
                if (modal.classList.contains("visible"))
                {
                    window.hideModal();
                }
            });
        }
    });

    const requiredInputs = document.querySelectorAll('form [required], form [data-required]');

    requiredInputs.forEach(field => {
        window.addRequiredLabel(field);
    });


    // Fetches the current session's CSRF token and updates the page with it, so later requests use it too
    async function refreshCsrfToken()
    {
        try {
            const response = await fetch('/csrf-token', { headers: { 'Accept': 'application/json' }, cache: 'no-store' });
            const data = response.ok ? await response.json() : null;
            if (data?.token)
            {
                document.querySelector('meta[name="csrf-token"]').setAttribute('content', data.token);
                document.querySelectorAll('input[name="_token"]').forEach(input => input.value = data.token);
                return true;
            }
        } catch (error) {
            console.error('Error:', error);
        }
        return false;
    }

    // Returns the decoded JSON on success, or { failed, status, message } so callers can always
    // recover. See docs/login-modal.md.
    async function ajaxPost(url, jsonData, retryOnExpiredToken = true)
    {
        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                },
                body: JSON.stringify(jsonData)
            });

            // 419: the page outlived its session (expiry, or a Filament logout in another tab).
            // Laravel rejects a 419 before the controller runs, so one retry cannot repeat a side effect.
            if (response.status === 419 && retryOnExpiredToken && await refreshCsrfToken())
            {
                return ajaxPost(url, jsonData, false);
            }

            const data = await response.json();
            if (response.ok && data)
            {
                return data;
            }
            return { failed: true, status: response.status, message: data?.message ?? '' };

        } catch (error) {
            console.error('Error:', error);
        }
        return { failed: true, status: 0, message: '' };
    }

    function clearLoginError(step)
    {
        const error = step.querySelector('.alert.error');
        if (error)
        {
            error.textContent = '';
        }
    }

    // Puts the step back and shows a message, so a failed request never leaves the spinner running
    function loginRequestFailed(result, loginForm, step)
    {
        if (result && !result.failed)
        {
            return false;
        }
        let message = 'Something went wrong. Please try again.';
        if (result?.status === 419)
        {
            message = 'This page has expired. Please refresh the page and try again.';
        }
        else if (result?.status === 422)
        {
            message = result.message || 'Please check your details and try again.';
        }
        else if (result?.status === 429)
        {
            message = 'Too many attempts. Please try again later.';
        }
        loginForm.classList.remove('loading');
        step.classList.add('active');
        const error = step.querySelector('.alert.error');
        if (error)
        {
            error.textContent = message;
            error.hidden = false;
        }
        return true;
    }

    //login modal
    const loginModal = document.querySelector("#modals_container .modal[data-modal-id=login]");
    if (loginModal)
    {
        loginModal.addEventListener('show', () => {
            window.goToLoginStep("email");
        });
    }

    //login form steps
    window.goToLoginStep = function(stepName)
    {
        var loginforms = document.querySelectorAll("form.login");
        if (loginforms)
        {
            loginforms.forEach(form =>
            {
                form.classList.remove("loading");
            });
            var allSteps = document.querySelectorAll("form.login .form_step");
            var thisSteps = document.querySelectorAll("form.login [data-step="+stepName+"]");
            if (thisSteps.length)
            {
                allSteps.forEach(step =>
                {
                    step.classList.remove("active");
                });
                thisSteps.forEach(step =>
                {
                    step.classList.add("active");
                });
            }
        }
    }

    const loginFormStepButtons = document.querySelectorAll("form.login .form_step_button");
    loginFormStepButtons.forEach(button =>
    {
        button.addEventListener('click', async (e) => {
            e.preventDefault();
            var step = document.querySelector(".login .form_step.active");
            var button = step.querySelector("button.form_step_button");
            const loginForm = step.closest("form.login");
            const postUrl = button.getAttribute("data-url");
            const redirect_url = loginForm.querySelector("input[name=redirect_url]").value;
            const emailAddress = loginForm.querySelector("input[name=email]").value;
            var data_step = step.getAttribute("data-step");
            console.log(data_step);
            switch (data_step)
            {
                case "email":
                    clearLoginError(step);
                    step.classList.remove("active");
                    loginForm.classList.add("loading");
                    const data = {
                        email: emailAddress,
                        redirect_url: redirect_url
                    };
                    let result = await ajaxPost(postUrl,data);
                    if (loginRequestFailed(result, loginForm, step)) break;
                    if (result)
                    {
                        if (result.exists)
                        {
                            if (result.has_password)
                            {
                                window.goToLoginStep("login");
                            }
                            else
                            {
                                window.goToLoginStep("no_password");
                            }
                        }
                        else
                        {
                            window.goToLoginStep("register");
                        }
                    }
                    break;
                case "register":
                    clearLoginError(step);
                    step.classList.remove("active");
                    loginForm.classList.add("loading");
                    const first_name = loginForm.querySelector("input[name=first_name]").value;
                    const last_name = loginForm.querySelector("input[name=last_name]").value;
                    const register = {
                        email: emailAddress,
                        first_name: first_name,
                        last_name: last_name,
                    };
                    let registration_result = await ajaxPost(postUrl, register);
                    if (loginRequestFailed(registration_result, loginForm, step)) break;
                    if (registration_result) {
                        if (registration_result.created) {
                            //check if const redirect_url is not empty
                            if (redirect_url && redirect_url.trim() !== "") {
                                window.location.href = redirect_url;
                            } else {
                                window.location.href = "/my-account";
                            }
                        }
                        else {
                            alert('There were some issues with your input, please try again');
                        }
                    }
                    break;
                case "login":

                    console.log('LOGIN TRY');
                    step.classList.remove("active");
                    loginForm.classList.add("loading");
                    const login_error = step.querySelector(".alert.error");
                    login_error.textContent = '';
                    const login = {
                        email: emailAddress,
                        password: document.querySelector("input[name=password]").value,
                    };
                    let login_result = await ajaxPost(postUrl, login);
                    if (loginRequestFailed(login_result, loginForm, step)) break;
                    if (login_result) {
                        if (login_result.success) {
                            //check if const redirect_url is not empty
                            if (redirect_url && redirect_url.trim() !== "") {
                                window.location.href = redirect_url;
                            } else {
                                window.location.href = "/my-account";
                            }
                        }
                        else {
                            loginForm.classList.remove("loading");
                            step.classList.add("active");
                            login_error.textContent = login_result.error;
                        }
                    }
                    break;
            }
        });
    });

    //vat toggles
    const vatToggles = document.querySelectorAll("input.vat_switch");
    vatToggles.forEach(vatToggle =>
    {
        vatToggle.addEventListener('change',() => {
            const showIncVat = vatToggle.checked;
            vatToggles.forEach(vatToggle => {
                vatToggle.checked = showIncVat;
                let vatToggleLabelText = "ex. VAT prices";
                if (showIncVat)
                {
                    vatToggleLabelText = "inc. VAT prices";
                    html.classList.remove("ex_vat");
                    html.classList.add("inc_vat");
                }
                else
                {
                    html.classList.remove("inc_vat");
                    html.classList.add("ex_vat");
                }
                const vatToggleLabel = vatToggle.nextElementSibling?.tagName === 'SPAN' ? vatToggle.nextElementSibling : false;
                if (vatToggleLabel)
                {
                    vatToggleLabel.textContent = vatToggleLabelText;
                }
            });
            //set cookie for one year
            document.cookie = `vat_preference=${showIncVat ? 'inc' : 'ex'}; path=/; max-age=31536000`;
        });
    });

    const changeLabelToggles = document.querySelectorAll("input.toggle_switch.change_label");
    changeLabelToggles.forEach(changeLabelToggle =>
    {
        changeLabelToggle.addEventListener('change',() => {
            const checked = changeLabelToggle.checked;
            if (checked && changeLabelToggle.dataset.checkedLabel)
            {
                changeLabelToggle.nextElementSibling.textContent = changeLabelToggle.dataset.checkedLabel;
            }
            else if (changeLabelToggle.dataset.uncheckedLabel)
            {
                changeLabelToggle.nextElementSibling.textContent = changeLabelToggle.dataset.uncheckedLabel;
            }
        });
        changeLabelToggle.dispatchEvent(new Event('change'));
    });

    //lazy loading images fade in
    document.querySelectorAll('img[loading="lazy"]').forEach(image => {
        window.fadeLazyLoadImage(image);
    });

    //scroll reveal
    const scrollRevealSlideUp = {
        distance: '20px',
        origin: 'bottom',
        opacity: 0,
        duration: 900,
        delay: 300,
        scale: 0.9
    };
    ScrollReveal().reveal('.scroll_reveal .reveal, .animate_bullets li',scrollRevealSlideUp);

    // read more containers
    document.querySelectorAll('.read_more_container').forEach(readMoreContainer => {
        const ps = readMoreContainer.getElementsByTagName("p");

        const paragraphs_to_show = parseInt(
            readMoreContainer.getAttribute("data-paragraphs-to-show"),
            10
        );

        // If there aren't more paragraphs than Laravel says to show, show everything
        if (isNaN(paragraphs_to_show) || paragraphs_to_show <= 0 || paragraphs_to_show >= ps.length) {
            return;
        }

        const last_visible_index = paragraphs_to_show - 1;

        ps[last_visible_index].insertAdjacentHTML(
            "beforeend",
            ' &nbsp;<a class="read_more_link">More</a>'
        );

        ps[last_visible_index]
            .querySelector(".read_more_link")
            .addEventListener("click", () => {
                readMoreContainer.classList.add("read_more");
            });
    });

    //scroll hint
    const scrollHintContainers = document.querySelectorAll(".scroll_hint");


    if (scrollHintContainers.length > 0)
    {
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                const element = entry.target;

                if (entry.isIntersecting && !element.dataset.bounced && element.scrollWidth > element.clientWidth) {
                    element.dataset.bounced = "true"; // Mark as bounced
                    setTimeout(function() { bounceScroll(element); }, 900);
                }
            });
        }, { threshold: 0.5 }); // Triggers when at least 50% is visible

        scrollHintContainers.forEach(container =>
            {
                console.log(container.offsetWidth);
                observer.observe(container);
            });
    }

    function bounceScroll(element)
    {
        element.scrollTo({ left: 20, behavior: "smooth" });
        setTimeout(() =>
            {
                element.scrollTo({ left: 0, behavior: "smooth" });
            }, 400);
    }

    quantitySelectors = document.querySelectorAll(`.quantity_selectors`);

    quantitySelectors.forEach(quantitySelector => {

        quantitySelector.addEventListener('click',(event) => {
            event.preventDefault();
            if (event.target)
            {
                if (event.target.classList.contains('increase'))
                {
                    const increaseButton = event.target;
                    const quantityField = increaseButton.previousElementSibling;
                    const max = (quantityField.getAttribute("max")===false) ? -1 : parseInt(quantityField.getAttribute("max"));
                    const currentQuantity = parseInt(quantityField.value);
                    quantityField.value = (max > -1 && ((currentQuantity + 1) > max)) ? max : currentQuantity + 1;
                    quantityField.dispatchEvent(new Event('change', { bubbles: true }));
                }
                else if (event.target.classList.contains('decrease'))
                {
                    const decreaseButton = event.target;
                    const quantityField = decreaseButton.nextElementSibling;
                    const min = (quantityField.getAttribute("min")===false) ? 0 : parseInt(quantityField.getAttribute("min"));
                    const currentQuantity = parseInt(quantityField.value);
                    quantityField.value = ((currentQuantity - 1) < min) ? min : currentQuantity - 1;
                    quantityField.dispatchEvent(new Event('change', { bubbles: true }));
                }
            }
        });

        quantitySelector.addEventListener('change',(event) => {
            if (event.target)
            {
                if (event.target.classList.contains('quantity_selector_quantity_field'))
                {
                    const quantityField = event.target;
                    const min = (quantityField.getAttribute("min")===false) ? 0 : parseInt(quantityField.getAttribute("min"));
                    const max = (quantityField.getAttribute("max")===false) ? -1 : parseInt(quantityField.getAttribute("max"));
                    const decreaseButton = quantityField.previousElementSibling;
                    const increaseButton = quantityField.nextElementSibling;
                    const currentQuantity = parseInt((quantityField.value.trim()==="") ? 0 : quantityField.value);
                    if (currentQuantity <= min)
                    {
                        quantityField.value = min;
                        decreaseButton.disabled = true;
                    }
                    else
                    {
                        decreaseButton.disabled = false;
                    }
                    if (currentQuantity >= max)
                    {
                        quantityField.value = max;
                        increaseButton.disabled = true;
                    }
                    else
                    {
                        increaseButton.disabled = false;
                    }
                }
            }
        });
    });

    // ------------------------------------------------------------------
    // Listing tile colour swatches (Stage 4 of the swatch plan).
    // Hovering a swatch shows that colour's thumbnail on the tile image and
    // it STAYS - no revert on mouse-out, only another swatch changes it.
    // Hovering also points the tile link at the colour's anchor, so the
    // link always matches the colour being shown.
    // CLICKING a swatch navigates to that colour's product page: the click
    // handler sets the anchored href (needed on touch, where no hover
    // precedes the tap) and then lets the event bubble on - the tile's <a>
    // follows the updated href and the GTM select_item handler below logs
    // it like any other tile click, which a swatch click-through now is.
    // Delegated, so it covers server-rendered tiles and ones rebuilt by
    // brokerage.js.
    // ------------------------------------------------------------------

    function listingTileImageFor(swatch)
    {
        return swatch.closest(".product_list_item")?.querySelector(".image_container > img");
    }

    function swapListingTileImage(img, swatch)
    {
        if (img.dataset.defaultAlt === undefined)
        {
            img.dataset.defaultAlt = img.getAttribute("alt") ?? "";
        }
        img.src = swatch.dataset.thumbnail;
        if (swatch.getAttribute("title"))
        {
            img.alt = (img.dataset.defaultAlt ? img.dataset.defaultAlt + " - " : "") + swatch.getAttribute("title");
        }
    }

    function selectListingSwatch(swatch)
    {
        const tile = swatch.closest(".product_list_item");

        if (swatch.dataset.thumbnail)
        {
            const img = listingTileImageFor(swatch);
            if (img)
            {
                swapListingTileImage(img, swatch);
            }
        }

        // Keep the click-through in step with the shown colour (D4: the tile
        // link follows whatever colour is being viewed).
        if (swatch.dataset.anchor)
        {
            const link = tile.querySelector("a.gtm-select-item") ?? tile.querySelector("a");
            if (link)
            {
                link.href = link.href.split("#")[0] + "#" + swatch.dataset.anchor;
            }
        }
    }

    document.addEventListener("mouseover", (event) => {
        const swatch = event.target.closest?.(".product_list_item .colours .colour_swatch");
        if (swatch)
        {
            selectListingSwatch(swatch);
        }
    });

    document.addEventListener("click", (event) => {
        const swatch = event.target.closest?.(".product_list_item .colours .colour_swatch");
        if (!swatch) return;

        // Set the anchored href before the browser follows the link - no
        // preventDefault: the navigation and the GTM logging are wanted.
        selectListingSwatch(swatch);
    }, true);

    document.addEventListener('click',(event) => {
        if (event.target)
        {
            const target = event.target;
            // Handle GTM select_item
            const selectItemLink = target.closest('.gtm-select-item');
            if (selectItemLink) {
                const productData = selectItemLink.closest('.product_list_item')?.dataset.gtmItem;
                if (productData) {
                    try {
                        const item = JSON.parse(productData);
                        const itemQuantity = parseFloat(item.quantity ?? 1);
                        const itemPrice = parseFloat(item.price ?? 0);
                        const itemTotal = Math.round((itemPrice * itemQuantity) * 100) / 100;
                        datalayerEvent({
                            event: 'select_item',
                            products: [item],
                            total: itemTotal,
                            item_list_id: item.item_list_id || null,
                            item_list_name: item.item_list_name || null
                        });
                    } catch (e) {
                        console.error('Error parsing GTM item data', e);
                    }
                }
            }

            if (target.closest('.basket_message_container, .basket_error_container') === null || target.innerHTML == "Close")
            {
                document.querySelector(".basket_message_container")?.classList.remove("visible");
                document.querySelector(".basket_error_container")?.classList.remove("visible");
                document.querySelector(".mini_basket_container .nav_link.basket")?.classList.remove("message","error");
            }
        }
    });


    //
});
